import { Box, Chip, Tooltip } from "@material-ui/core";
import React, { useCallback } from "react";
import { isJSONString } from "src/components/utils";
import clsx from "clsx";
import { BadgedChip } from "../../virtualizedTable/tooltipTableCell";

function BadgedChipComponent({ value, classes }) {
  const convertedValue = useCallback(() => {
    if (isJSONString(value)) {
      return JSON.parse(value);
    } else {
      return value;
    }
  }, [value])();

  return (
    <Tooltip
      title={
        convertedValue &&
        Object.keys(convertedValue).map((itemKey, index) => (
          <React.Fragment key={index}>
            · {itemKey}:{convertedValue[itemKey]} <br />
          </React.Fragment>
        ))
      }
      placement="top-start"
    >
      <Box className={classes.chipBox} noWrap>
        {convertedValue &&
          Object.keys(convertedValue).map((itemKey, index) => (
            <Chip
              className={clsx({
                [classes["yellow[600]-background"]]: itemKey === "VUS",
                [classes["amber[500]-background"]]: itemKey === "VUSi",
                [classes["orange[500]-background"]]: itemKey === "VUSii",
                [classes["lightGreen[500]-background"]]: itemKey === "LB",
                [classes["green[500]-background"]]: itemKey === "B",
                [classes["red[500]-background"]]: itemKey === "LP",
                [classes["red[900]-background"]]: itemKey === "P",
                [classes.chip]: true,
              })}
              label={
                <BadgedChip
                  classes={classes}
                  itemKey={itemKey}
                  key={index}
                  data={convertedValue}
                  index={index}
                />
              }
            />
          ))}
      </Box>
    </Tooltip>
  );
}

export default BadgedChipComponent;
